<ng-container>
	<img src="/assets/images/cloud-error.svg" alt="error image" width="65" height="105">
	<p id="notifications-error-text" class="zk-pb-4 zk-flex zk-text-center" freud-typography fontType="h6Regular1-5">
		{{ 'NOTIFICATIONS.CARD.ERROR' | translate }}
	</p>
</ng-container>